import { createFileRoute } from "@tanstack/react-router";

import { ZoneFormPage } from "@/components/zones/form";
import { RequirePermission } from "@/hooks/shared/CheckAuth";

export const Route = createFileRoute("/_main/dashboard/zones/new")({
  component: () => (
    <RequirePermission action="zones.write">
      <ZoneFormPage />
    </RequirePermission>
  ),
});
